export default function formatNum(number, lang){
    if (typeof number == 'string') return number
    return new Intl.NumberFormat(lang == "ru" ? "ru-RU" : "en-EN").format(number)
}